var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-expansion-panels',_vm._g(_vm._b({model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}},'v-expansion-panels',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }